import { render, staticRenderFns } from "./DataTableDiscounts.vue?vue&type=template&id=b99c2ade&scoped=true"
import script from "./DataTableDiscounts.vue?vue&type=script&lang=js"
export * from "./DataTableDiscounts.vue?vue&type=script&lang=js"
import style0 from "./DataTableDiscounts.vue?vue&type=style&index=0&id=b99c2ade&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b99c2ade",
  null
  
)

export default component.exports